import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setSensori,
  addSensori,
  setSingleSensore,
  updateSensori,
  deleteSensori,
  setWeatherData,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure
} from "./sensoriSlice";
import sensoriAPI from "../../services/sensoriAPI";
import { toast } from "react-toastify";
// Fetch all sensori
export const fetchSensori = createAsyncThunk(
  "sensori/fetchSensori",
  async (_, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await sensoriAPI.getAllSensori();
      dispatch(setSensori(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch sensori.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);
// Fetch single stabilimento
export const fetchSingleSensore = createAsyncThunk(
  "sensori/fetchSingleSensore",
  async (sensoreId, { dispatch }) => {
    dispatch(apiRequestStart());  // Dispatch API request start
    try {
      const response = await sensoriAPI.getSensori(sensoreId);  // Make the API call
      dispatch(setSingleSensore(response.data.data));  // Dispatch action to set the sensore data
      dispatch(apiRequestSuccess());  // Dispatch API request success
      return response.data;  // Return the fetched data
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch sensore.";  // Handle error
      dispatch(apiRequestFailure(errorMessage));  // Dispatch API request failure
      throw new Error(errorMessage);  // Throw error for further handling
    }
  }
);
// Create new sensore
export const createSensore = createAsyncThunk(
  "sensori/createSensore",
  async (payload, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await sensoriAPI.createSensori(payload);
      dispatch(addSensori(response.data.data));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to create sensore.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);
// Update sensore
export const updateSensore = createAsyncThunk(
    "sensori/updateSensore",
    async ({ id, data }, { dispatch }) => {
      dispatch(apiRequestStart());
      try {
        const response = await sensoriAPI.updateSensori(id, data);
        dispatch(updateSensori(response.data.data));
        toast.success(response?.data?.message)
        dispatch(apiRequestSuccess());
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to update sensore.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  );
// Delete sensore
export const deleteSensore = createAsyncThunk(
  "sensori/deleteSensore",
  async (id, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
    const response =  await sensoriAPI.deletesensori(id);
      dispatch(deleteSensori(id));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return id;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete sensore.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// fetching weather data
export const fetchWeatherData = createAsyncThunk(
  "sensori/fetchWeatherData",
  async ({filter, sensore_name} , { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await sensoriAPI.getWeatherData(filter, sensore_name);
      dispatch(setWeatherData(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch weather data.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);